var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article"},[_c('PageTitle',{attrs:{"title":_vm.article ? _vm.lemmaDisplay : '',"pretitle":'Article details'}}),(_vm.article)?_c('ArticleDetails',{attrs:{"article":_vm.article}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }